'use client';

import { styles } from './ContentSection.styles';
type NativeElement = React.HTMLAttributes<HTMLDivElement>;

export interface ContentSectionProps {
  id?: string;
  leftBlock?: React.ReactNode;
  leftBlockClassName?: string;
  rightBlock?: React.ReactNode;
  rightBlockClassName?: string;
  onClick?: NativeElement['onClick'];
}

export function ContentSection({
  id,
  leftBlock,
  leftBlockClassName,
  rightBlock,
  rightBlockClassName,
  ...props
}: ContentSectionProps) {
  const slots = styles();

  return (
    <div
      id={id}
      className={slots.base()}
      {...props}
    >
      <div className={slots.wrap()}>
        {leftBlock && (
          <div className={slots.left({ className: leftBlockClassName })}>
            {leftBlock}
          </div>
        )}

        {rightBlock && (
          <div className={slots.right({ className: rightBlockClassName })}>
            {rightBlock}
          </div>
        )}
      </div>
    </div>
  );
}
